import { render, staticRenderFns } from "./SetUserAsAdminModal.vue?vue&type=template&id=2d2262ab&scoped=true&"
import script from "./SetUserAsAdminModal.vue?vue&type=script&lang=js&"
export * from "./SetUserAsAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./SetUserAsAdminModal.vue?vue&type=style&index=0&id=2d2262ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2262ab",
  null
  
)

export default component.exports